import { newGame } from "../engine/engine";
import { randomSeed } from "../engine/deck";
import { DEFAULT_RULESET, GameState, Ruleset, SeatIndex } from "../types/game";
import { Difficulty } from "../ai/bot";

// Bot screen names — randomized so games don't feel repetitive.
const BOT_NAMES = [
  "Val", "Rook", "Dealer", "Ace",
  "Queenie", "Jack", "Nine",
  "Pip", "Slim", "Chip", "Hank",
  "Mark", "Donna", "Sara", "Phil",
  "Randy", "Linda", "Fred", "Susan",
  "Karen", "Amy", "Dennis", "Matt",
  "Debbie", "Katherine", "Joe", "Ed",
  "Sue", "Scottee", "Chris", "Erin",
  "Judy", "Dave", "Jeff", "Sean",
  "Nick", "Craig", "Gary", "John",
  "Mike", "Paul", "Keith", "Derrick",
  "Kurt", "Sam", "Carm", "Marylin",
  "Andy", "Roger", "Barry", "Kristen",
  "Kevin", "Tom",
];

function pickBotNames(n: number): string[] {
  const pool = [...BOT_NAMES];
  const out: string[] = [];
  for (let i = 0; i < n; i++) {
    const idx = Math.floor(Math.random() * pool.length);
    out.push(pool.splice(idx, 1)[0]);
  }
  return out;
}

export interface QuickPlayConfig {
  userUid: string;
  userScreenName: string;
  partnerDifficulty: Difficulty;
  opponentDifficulty: Difficulty;
  ruleset?: Ruleset;
}

// Human sits at seat 0 (Team A). Partner is seat 2 (Team A). Opponents are 1 and 3 (Team B).
export function startQuickPlay(cfg: QuickPlayConfig): GameState {
  const [n1, n2, n3] = pickBotNames(3);
  const seed = randomSeed();
  // Same rule as multiplayer matches.ts: deterministic from seed, uniform over seats.
  const firstDealer: SeatIndex = ((seed >>> 3) % 4) as SeatIndex;
  return newGame(
    seed,
    [
      { seat: 0 as SeatIndex, uid: cfg.userUid, screenName: cfg.userScreenName },
      { seat: 1 as SeatIndex, screenName: n1, botDifficulty: cfg.opponentDifficulty },
      { seat: 2 as SeatIndex, screenName: n2, botDifficulty: cfg.partnerDifficulty },
      { seat: 3 as SeatIndex, screenName: n3, botDifficulty: cfg.opponentDifficulty },
    ],
    firstDealer,
    cfg.ruleset ?? DEFAULT_RULESET,
  );
}
